/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InitiativeKpiSampleDto } from './InitiativeKpiSampleDto';
import {
    InitiativeKpiSampleDtoFromJSON,
    InitiativeKpiSampleDtoFromJSONTyped,
    InitiativeKpiSampleDtoToJSON,
    InitiativeKpiSampleDtoToJSONTyped,
} from './InitiativeKpiSampleDto';

/**
 * 
 * @export
 * @interface InitiativeKpiDefinitionDto
 */
export interface InitiativeKpiDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    kpiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    direction?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeKpiDefinitionDto
     */
    targetValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeKpiDefinitionDto
     */
    warningValue?: number;
    /**
     * 
     * @type {number}
     * @memberof InitiativeKpiDefinitionDto
     */
    breachValue?: number;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    sourceModule?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    sourceRef?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InitiativeKpiDefinitionDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InitiativeKpiDefinitionDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeKpiDefinitionDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InitiativeKpiDefinitionDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {Array<InitiativeKpiSampleDto>}
     * @memberof InitiativeKpiDefinitionDto
     */
    recentSamples?: Array<InitiativeKpiSampleDto>;
    /**
     * 
     * @type {InitiativeKpiSampleDto}
     * @memberof InitiativeKpiDefinitionDto
     */
    latestSample?: InitiativeKpiSampleDto;
}

/**
 * Check if a given object implements the InitiativeKpiDefinitionDto interface.
 */
export function instanceOfInitiativeKpiDefinitionDto(value: object): value is InitiativeKpiDefinitionDto {
    return true;
}

export function InitiativeKpiDefinitionDtoFromJSON(json: any): InitiativeKpiDefinitionDto {
    return InitiativeKpiDefinitionDtoFromJSONTyped(json, false);
}

export function InitiativeKpiDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeKpiDefinitionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'kpiKey': json['kpiKey'] == null ? undefined : json['kpiKey'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'direction': json['direction'] == null ? undefined : json['direction'],
        'targetValue': json['targetValue'] == null ? undefined : json['targetValue'],
        'warningValue': json['warningValue'] == null ? undefined : json['warningValue'],
        'breachValue': json['breachValue'] == null ? undefined : json['breachValue'],
        'sourceModule': json['sourceModule'] == null ? undefined : json['sourceModule'],
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'active': json['active'] == null ? undefined : json['active'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'recentSamples': json['recentSamples'] == null ? undefined : ((json['recentSamples'] as Array<any>).map(InitiativeKpiSampleDtoFromJSON)),
        'latestSample': json['latestSample'] == null ? undefined : InitiativeKpiSampleDtoFromJSON(json['latestSample']),
    };
}

export function InitiativeKpiDefinitionDtoToJSON(json: any): InitiativeKpiDefinitionDto {
    return InitiativeKpiDefinitionDtoToJSONTyped(json, false);
}

export function InitiativeKpiDefinitionDtoToJSONTyped(value?: InitiativeKpiDefinitionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'initiativeId': value['initiativeId'],
        'kpiKey': value['kpiKey'],
        'displayName': value['displayName'],
        'unit': value['unit'],
        'direction': value['direction'],
        'targetValue': value['targetValue'],
        'warningValue': value['warningValue'],
        'breachValue': value['breachValue'],
        'sourceModule': value['sourceModule'],
        'sourceRef': value['sourceRef'],
        'active': value['active'],
        'notes': value['notes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'recentSamples': value['recentSamples'] == null ? undefined : ((value['recentSamples'] as Array<any>).map(InitiativeKpiSampleDtoToJSON)),
        'latestSample': InitiativeKpiSampleDtoToJSON(value['latestSample']),
    };
}

